/** 任务状态 / 类型中文文案（任务调度与救援流向共用） */

export const taskStatusLabel: Record<string, string> = {
  pending: '待派发',
  assigned: '已派发',
  accepted: '已接受',
  done: '已完成',
  timeout: '已超时',
}

export const taskTypeLabel: Record<string, string> = {
  rescue: '救援',
  transport: '转运',
  medical: '医疗',
  report: '灾情上报',
}
